var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5C5 5.67157 5.67157 5 6.5 5H48.5C49.3284 5 50 5.67157 50 6.5C50 7.32843 49.3284 8 48.5 8H6.5C5.67157 8 5 7.32843 5 6.5Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5C5 10.6716 5.67157 10 6.5 10H48.5C49.3284 10 50 10.6716 50 11.5C50 12.3284 49.3284 13 48.5 13H6.5C5.67157 13 5 12.3284 5 11.5Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5C5 15.6716 5.67157 15 6.5 15H48.5C49.3284 15 50 15.6716 50 16.5C50 17.3284 49.3284 18 48.5 18H6.5C5.67157 18 5 17.3284 5 16.5Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.5C5 20.6716 5.67157 20 6.5 20H48.5C49.3284 20 50 20.6716 50 21.5C50 22.3284 49.3284 23 48.5 23H6.5C5.67157 23 5 22.3284 5 21.5Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.5C5 25.6716 5.67157 25 6.5 25H39.5C40.3284 25 41 25.6716 41 26.5C41 27.3284 40.3284 28 39.5 28H6.5C5.67157 28 5 27.3284 5 26.5Z",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 31.5C5 30.6716 5.67157 30 6.5 30H48.5C49.3284 30 50 30.6716 50 31.5C50 32.3284 49.3284 33 48.5 33H6.5C5.67157 33 5 32.3284 5 31.5Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 36.5C5 35.6716 5.67157 35 6.5 35H48.5C49.3284 35 50 35.6716 50 36.5C50 37.3284 49.3284 38 48.5 38H6.5C5.67157 38 5 37.3284 5 36.5Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 41.5C5 40.6716 5.67157 40 6.5 40H48.5C49.3284 40 50 40.6716 50 41.5C50 42.3284 49.3284 43 48.5 43H6.5C5.67157 43 5 42.3284 5 41.5Z",
    fill: "#F5F5F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 46.5C5 45.6716 5.67157 45 6.5 45H24.5C25.3284 45 26 45.6716 26 46.5C26 47.3284 25.3284 48 24.5 48H6.5C5.67157 48 5 47.3284 5 46.5Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/BOX.7a2a1374ecf5b2e71e53dc142ef6ab1b.svg";
export { ForwardRef as ReactComponent };